import { Input, InputProps, InputTypeMap } from "@mui/joy";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { currencyFormatter } from "../../constants";

/**
 *
 * @param props
 * @returns {ReactElement} CurrencyInput page
 */
export function CurrencyInput(props: InputProps) {
  const [focus, setFocused] = useState(false);
  const [value, setValue] = useState(`${props.value}`);

  useEffect(() => {
    setValue(`${props.value}`);
  }, [props.value]);

  useEffect(() => {
    if (!isNaN(parseFloat(value))) setValue(`${props.value}`);
  }, [props.value]);

  let formatted = "";
  if (!isNaN(parseFloat(value)))
    formatted = currencyFormatter.format(parseFloat(value));

  return (
    <Input
      {...props}
      value={focus ? value : formatted}
      onChange={(e) => {
        setValue(e.target.value);
        if (!isNaN(parseFloat(e.target.value))) props?.onChange(e);
      }}
      onFocus={(e) => {
        if (props.onFocus) props.onFocus(e);
        setFocused(true);
      }}
      onBlur={(e) => {
        if (props.onBlur) props.onBlur(e);
        setFocused(false);
      }}
    />
  );
}
